import { mountModal } from 'lib/modal';
import _ from 'lodash';
import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';
import * as React from 'react';
import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './styles/ModalTrigger.scss';

/**
 * Invoke [Dialog](/internal/components/Dialog) with focus-able element.
 *
 *
 * ```example
 * <ModalTrigger
 *   modal={
 *     <Dialog
 *       title="Dialog title"
 *       subtext="Dialog subtext">
 *       <BoxBody>
 *         Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *         ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *         ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *         reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *       </BoxBody>
 *     </Dialog>
 *   }>
 *   <Button>Show Dialog</Button>
 * </ModalTrigger>
 * ```
 *
 *
 * # TODO
 * * Enforce focus-able child
 */

class ModalTrigger extends React.Component<{
  modal: React.ReactElement<any>;
  children?: React.ReactElement<any>; // Flow issue facebook/flow#1355
  className?: string;
  onClick?: () => void;
}> {
  handleClick: MouseEventHandler = (event) => {
    event?.preventDefault();
    if (this.props.modal) {
      mountModal(this.props.modal, this);
      if (this.props.onClick) {
        this.props.onClick();
      }
    }
  };

  render() {
    const { children, className, ...others } = this.props;
    const child = React.Children.only(children);

    if (!child) {
      return null;
    }

    const childProps = Object.assign(_.omit(others, ['modal']), {
      className: cx('ModalTrigger', child.props.className, className),
      onClick: createChainedFunction(this.handleClick, child.props.onClick),
    });

    return React.cloneElement(child, childProps);
  }
}

export default ModalTrigger;
